// 集中管理 SEO 常量与 Schema.org JSON-LD 结构。
// 站点域名通过环境变量 VITE_SITE_URL 提供，缺失时回退到项目正式域名。

const env = import.meta.env as Record<string, string | undefined>;

export const SITE_URL = env.VITE_SITE_URL || "https://usfanslink.sbs";
export const SITE_NAME = "USFans Spreadsheet";
export const SITE_LOGO =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";
export const SITE_DESCRIPTION =
  "USFans Spreadsheet guide to products, sellers, shipping cost, warehouse info, coupons, QC and safety. Browse categories and find buying resources faster.";

export const organizationSchema = {
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: { "@type": "ImageObject", url: SITE_LOGO },
};

export function buildHomeSchema() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      organizationSchema,
      {
        "@type": "WebSite",
        name: SITE_NAME,
        url: SITE_URL,
        description: SITE_DESCRIPTION,
        publisher: organizationSchema,
      },
    ],
  };
}

interface ArticleLike {
  slug: string;
  title: string;
  shortAnswer: string;
  author: string;
  heroImage: string;
  faq: { q: string; a: string }[];
}

export function buildArticleSchema(article: ArticleLike) {
  const url = `${SITE_URL}/guide/${article.slug}`;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "BlogPosting",
        headline: article.title,
        description: article.shortAnswer,
        image: article.heroImage,
        datePublished: "2026-08-01",
        dateModified: "2026-08-21",
        author: { "@type": "Organization", name: article.author, url: SITE_URL },
        publisher: organizationSchema,
        mainEntityOfPage: { "@type": "WebPage", "@id": url },
        url,
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
          {
            "@type": "ListItem",
            position: 2,
            name: "Guides",
            item: `${SITE_URL}/#guides`,
          },
          { "@type": "ListItem", position: 3, name: article.title, item: url },
        ],
      },
      {
        "@type": "FAQPage",
        mainEntity: article.faq.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  };
}